const column = [
  {
    label: "Index name",
    field: "name"
  },
  {
    label: "Country/Region",
    field: "location"
  },
  {
    label: "Statistical cycle",
    field: "time"
  },
  {
    label: "Unit",
    field: "unit"
  },
  {
    label: "Source",
    field: "resource"
  }
]

export default column;